import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio } from "vue"
import _imports_0 from '@/assets/images/admin-img/dashboard-banners-icon.svg'
import _imports_1 from '@/assets/images/admin-img/dashboard-articles-icon.svg'
import _imports_2 from '@/assets/images/admin-img/dashboard-services-icon.svg'
import _imports_3 from '@/assets/images/admin-img/dashboard-industry-icon.svg'
import _imports_4 from '@/assets/images/admin-img/dashboard-clients-icon.svg'
import _imports_5 from '@/assets/images/admin-img/dashboard-jobs-icon.svg'
import _imports_6 from '@/assets/images/admin-img/dashboard-blogs-icon.svg'
import _imports_7 from '@/assets/images/admin-img/dashboard-contact-us-icon.svg'
import _imports_8 from '@/assets/images/admin-img/gray-pdf-icon.svg'
import _imports_9 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "dashboard-page" }
const _hoisted_10 = { class: "admin-custom-row" }
const _hoisted_11 = { class: "item-4 dashboard-item-col" }
const _hoisted_12 = { class: "banners-bg radius-10 admin-padding-15" }
const _hoisted_13 = { class: "dashboard-item-col-top" }
const _hoisted_14 = { class: "dashboard-item-col-top-left" }
const _hoisted_15 = { class: "dashboard-item-col-top-right" }
const _hoisted_16 = { class: "dashboard-item-col-mid" }
const _hoisted_17 = { class: "dashboard-item-col-mid-left" }
const _hoisted_18 = { class: "dashboard-item-col-btm" }
const _hoisted_19 = { class: "btn-set-left-align" }
const _hoisted_20 = { class: "item-4 dashboard-item-col" }
const _hoisted_21 = { class: "articles-bg radius-10 admin-padding-15" }
const _hoisted_22 = { class: "dashboard-item-col-top" }
const _hoisted_23 = { class: "dashboard-item-col-top-left" }
const _hoisted_24 = { class: "dashboard-item-col-top-right" }
const _hoisted_25 = { class: "dashboard-item-col-mid" }
const _hoisted_26 = { class: "dashboard-item-col-mid-left" }
const _hoisted_27 = { class: "dashboard-item-col-btm" }
const _hoisted_28 = { class: "btn-set-left-align" }
const _hoisted_29 = { class: "item-4 dashboard-item-col" }
const _hoisted_30 = { class: "services-bg radius-10 admin-padding-15" }
const _hoisted_31 = { class: "dashboard-item-col-top" }
const _hoisted_32 = { class: "dashboard-item-col-top-left" }
const _hoisted_33 = { class: "dashboard-item-col-top-right" }
const _hoisted_34 = { class: "dashboard-item-col-mid" }
const _hoisted_35 = { class: "dashboard-item-col-mid-left" }
const _hoisted_36 = { class: "dashboard-item-col-btm" }
const _hoisted_37 = { class: "btn-set-left-align" }
const _hoisted_38 = { class: "item-5 dashboard-item-col dashboard-item-col-sm" }
const _hoisted_39 = { class: "industry-bg radius-10 admin-padding-15" }
const _hoisted_40 = { class: "dashboard-item-col-top" }
const _hoisted_41 = { class: "dashboard-item-col-top-left" }
const _hoisted_42 = { class: "dashboard-item-col-top-right" }
const _hoisted_43 = { class: "dashboard-item-col-mid" }
const _hoisted_44 = { class: "dashboard-item-col-mid-left" }
const _hoisted_45 = { class: "dashboard-item-col-btm" }
const _hoisted_46 = { class: "btn-set-left-align" }
const _hoisted_47 = { class: "item-5 dashboard-item-col dashboard-item-col-sm" }
const _hoisted_48 = { class: "clients-bg radius-10 admin-padding-15" }
const _hoisted_49 = { class: "dashboard-item-col-top" }
const _hoisted_50 = { class: "dashboard-item-col-top-left" }
const _hoisted_51 = { class: "dashboard-item-col-top-right" }
const _hoisted_52 = { class: "dashboard-item-col-mid" }
const _hoisted_53 = { class: "dashboard-item-col-mid-left" }
const _hoisted_54 = { class: "dashboard-item-col-btm" }
const _hoisted_55 = { class: "btn-set-left-align" }
const _hoisted_56 = { class: "item-5 dashboard-item-col dashboard-item-col-sm" }
const _hoisted_57 = { class: "jobs-bg radius-10 admin-padding-15" }
const _hoisted_58 = { class: "dashboard-item-col-top" }
const _hoisted_59 = { class: "dashboard-item-col-top-left" }
const _hoisted_60 = { class: "dashboard-item-col-top-right" }
const _hoisted_61 = { class: "dashboard-item-col-mid" }
const _hoisted_62 = { class: "dashboard-item-col-mid-left" }
const _hoisted_63 = { class: "dashboard-item-col-btm" }
const _hoisted_64 = { class: "btn-set-left-align" }
const _hoisted_65 = { class: "item-5 dashboard-item-col dashboard-item-col-sm" }
const _hoisted_66 = { class: "blogs-bg radius-10 admin-padding-15" }
const _hoisted_67 = { class: "dashboard-item-col-top" }
const _hoisted_68 = { class: "dashboard-item-col-top-left" }
const _hoisted_69 = { class: "dashboard-item-col-top-right" }
const _hoisted_70 = { class: "dashboard-item-col-mid" }
const _hoisted_71 = { class: "dashboard-item-col-mid-left" }
const _hoisted_72 = { class: "dashboard-item-col-btm" }
const _hoisted_73 = { class: "btn-set-left-align" }
const _hoisted_74 = { class: "item-5 dashboard-item-col dashboard-item-col-sm" }
const _hoisted_75 = { class: "contact-us-bg radius-10 admin-padding-15" }
const _hoisted_76 = {
  class: "dashboard-item-col-top",
  style: {"opacity":"0"}
}
const _hoisted_77 = { class: "dashboard-item-col-top-left" }
const _hoisted_78 = { class: "dashboard-item-col-top-right" }
const _hoisted_79 = { class: "dashboard-item-col-mid" }
const _hoisted_80 = { class: "dashboard-item-col-mid-left" }
const _hoisted_81 = { class: "dashboard-item-col-btm" }
const _hoisted_82 = { class: "btn-set-left-align" }
const _hoisted_83 = { class: "item-2 dashboard-item" }
const _hoisted_84 = { class: "radius-10 admin-padding-15 dashboard-team-box" }
const _hoisted_85 = { class: "dashboard-item-top" }
const _hoisted_86 = { class: "dashboard-tabs" }
const _hoisted_87 = { class: "dashboard-item-btm" }
const _hoisted_88 = { class: "dashboard-team-row published-team" }
const _hoisted_89 = { class: "dashboard-team-box" }
const _hoisted_90 = { class: "dashboard-team-box-img" }
const _hoisted_91 = ["src"]
const _hoisted_92 = { class: "dashboard-team-box-name" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = {
  class: "dashboard-team-row unpublished-team",
  style: {"display":"none"}
}
const _hoisted_95 = { class: "dashboard-team-box" }
const _hoisted_96 = { class: "dashboard-team-box-img" }
const _hoisted_97 = ["src"]
const _hoisted_98 = { class: "dashboard-team-box-name" }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { class: "btn-set-left-align" }
const _hoisted_101 = { class: "item-2 dashboard-item" }
const _hoisted_102 = { class: "radius-10 admin-padding-15 dashboard-join-team-box" }
const _hoisted_103 = { class: "dashboard-item-top" }
const _hoisted_104 = { class: "dashboard-item-btm" }
const _hoisted_105 = { class: "dashboard-join-team-row" }
const _hoisted_106 = { class: "dashboard-join-team-col dashboard-join-team-hd" }
const _hoisted_107 = { class: "dashboard-join-team-img" }
const _hoisted_108 = { class: "dashboard-join-team-name" }
const _hoisted_109 = { class: "dashboard-join-team-designation" }
const _hoisted_110 = { class: "dashboard-join-team-action" }
const _hoisted_111 = { class: "dashboard-join-team-list" }
const _hoisted_112 = { class: "dashboard-join-team-img" }
const _hoisted_113 = ["src"]
const _hoisted_114 = { class: "dashboard-join-team-name" }
const _hoisted_115 = { class: "dashboard-join-team-designation" }
const _hoisted_116 = { class: "dashboard-join-team-action" }
const _hoisted_117 = ["onClick"]
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { class: "btn-set-left-align" }
const _hoisted_120 = { class: "item-2 dashboard-item" }
const _hoisted_121 = { class: "radius-10 admin-padding-15 dashboard-job-category-box" }
const _hoisted_122 = { class: "dashboard-item-top" }
const _hoisted_123 = { class: "dashboard-item-btm" }
const _hoisted_124 = { class: "dashboard-job-category-row" }
const _hoisted_125 = { class: "dashboard-job-category-col dashboard-job-category-hd" }
const _hoisted_126 = { class: "dashboard-job-category-title" }
const _hoisted_127 = { class: "dashboard-job-category-active-inactive" }
const _hoisted_128 = { class: "dashboard-job-category-action" }
const _hoisted_129 = { class: "dashboard-job-category-list" }
const _hoisted_130 = { class: "dashboard-job-category-title" }
const _hoisted_131 = { class: "dashboard-job-category-active-inactive" }
const _hoisted_132 = ["onClick"]
const _hoisted_133 = ["name", "onUpdate:modelValue"]
const _hoisted_134 = ["name", "onUpdate:modelValue"]
const _hoisted_135 = { class: "dashboard-job-category-action" }
const _hoisted_136 = { class: "admin-action-link" }
const _hoisted_137 = ["onClick"]
const _hoisted_138 = ["onClick"]
const _hoisted_139 = { class: "btn-set-left-align" }
const _hoisted_140 = { class: "item-2 dashboard-item" }
const _hoisted_141 = { class: "radius-10 admin-padding-15 dashboard-blog-category-box" }
const _hoisted_142 = { class: "dashboard-item-top" }
const _hoisted_143 = { class: "dashboard-item-btm" }
const _hoisted_144 = { class: "dashboard-job-category-row" }
const _hoisted_145 = { class: "dashboard-blog-category-col dashboard-blog-category-hd" }
const _hoisted_146 = { class: "dashboard-blog-category-title" }
const _hoisted_147 = { class: "dashboard-blog-category-active-inactive" }
const _hoisted_148 = { class: "dashboard-blog-category-action" }
const _hoisted_149 = { class: "dashboard-blog-category-list" }
const _hoisted_150 = { class: "dashboard-blog-category-title" }
const _hoisted_151 = { class: "dashboard-blog-category-active-inactive" }
const _hoisted_152 = ["onClick"]
const _hoisted_153 = ["name", "onUpdate:modelValue"]
const _hoisted_154 = ["name", "onUpdate:modelValue"]
const _hoisted_155 = { class: "dashboard-blog-category-action" }
const _hoisted_156 = { class: "admin-action-link" }
const _hoisted_157 = ["onClick"]
const _hoisted_158 = ["onClick"]
const _hoisted_159 = { class: "btn-set-left-align" }
const _hoisted_160 = { class: "admin-site-footer" }
const _hoisted_161 = { class: "container" }
const _hoisted_162 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_163 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_164 = { class: "modal-content" }
const _hoisted_165 = { class: "confirmation-popup-mid" }
const _hoisted_166 = { class: "confirmation-popup-btm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.DASHBOARD_TEXT), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.TOTAL_TEXT), 1),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("i", null, _toDisplayString(_ctx.bannerCounts.all), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.UNPUBLISHED_TEXT) + ": ", 1),
                        _createElementVNode("i", null, _toDisplayString(_ctx.bannerCounts.unpublished), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.bannerCounts.published), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.PUBLISHED_BANNERS_TEXT), 1)
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "dashboard-item-col-mid-right" }, [
                        _createElementVNode("div", { class: "dashboard-item-col-icon" }, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          })
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          to: "/authority/Banners",
                          id: "bannerDetailsLink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.TOTAL_TEXT), 1),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createElementVNode("i", null, _toDisplayString(_ctx.articleCounts.all), 1)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.UNPUBLISHED_TEXT) + ": ", 1),
                        _createElementVNode("i", null, _toDisplayString(_ctx.articleCounts.unpublished), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.articleCounts.published), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.PUBLISHED_ARTICLES_TEXT), 1)
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "dashboard-item-col-mid-right" }, [
                        _createElementVNode("div", { class: "dashboard-item-col-icon" }, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: ""
                          })
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_router_link, {
                          to: "/authority/articles",
                          id: "articlesDetailsLink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.TOTAL_TEXT), 1),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        _createElementVNode("i", null, _toDisplayString(_ctx.serviceCounts.all), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.UNPUBLISHED_TEXT) + ": ", 1),
                        _createElementVNode("i", null, _toDisplayString(_ctx.serviceCounts.unpublished), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.serviceCounts.published), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.PUBLISHED_SERVICES_TEXT), 1)
                      ]),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "dashboard-item-col-mid-right" }, [
                        _createElementVNode("div", { class: "dashboard-item-col-icon" }, [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: ""
                          })
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_router_link, {
                          to: "/authority/services",
                          id: "servicesDetailsLink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.TOTAL_TEXT), 1),
                        _cache[10] || (_cache[10] = _createTextVNode()),
                        _createElementVNode("i", null, _toDisplayString(_ctx.industryCounts.all), 1)
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.UNPUBLISHED_TEXT), 1),
                        _cache[11] || (_cache[11] = _createTextVNode()),
                        _createElementVNode("i", null, _toDisplayString(_ctx.industryCounts.unpublished), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.industryCounts.published), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.PUBLISHED_INDUSTRY_TEXT), 1)
                      ]),
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "dashboard-item-col-mid-right" }, [
                        _createElementVNode("div", { class: "dashboard-item-col-icon" }, [
                          _createElementVNode("img", {
                            src: _imports_3,
                            alt: ""
                          })
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_router_link, {
                          to: "/authority/industry",
                          id: "industryDetailsLink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.TOTAL_TEXT), 1),
                        _cache[13] || (_cache[13] = _createTextVNode()),
                        _createElementVNode("i", null, _toDisplayString(_ctx.clientCounts.all), 1)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.UNPUBLISHED_TEXT), 1),
                        _createElementVNode("i", null, _toDisplayString(_ctx.clientCounts.unpublished), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.clientCounts.published), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.PUBLISHED_CLIENTS_TEXT), 1)
                      ]),
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "dashboard-item-col-mid-right" }, [
                        _createElementVNode("div", { class: "dashboard-item-col-icon" }, [
                          _createElementVNode("img", {
                            src: _imports_4,
                            alt: ""
                          })
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_router_link, {
                          to: "/authority/clients",
                          id: "industryDetailsLink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.TOTAL_TEXT), 1),
                        _cache[15] || (_cache[15] = _createTextVNode()),
                        _createElementVNode("i", null, _toDisplayString(_ctx.jobCounts.all), 1)
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.UNPUBLISHED_TEXT), 1),
                        _createElementVNode("i", null, _toDisplayString(_ctx.jobCounts.unpublished), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.jobCounts.published), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.PUBLISHED_JOBS_TEXT), 1)
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "dashboard-item-col-mid-right" }, [
                        _createElementVNode("div", { class: "dashboard-item-col-icon" }, [
                          _createElementVNode("img", {
                            src: _imports_5,
                            alt: ""
                          })
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_router_link, {
                          to: "/authority/manage-job",
                          id: "jobsDetailslink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.TOTAL_TEXT), 1),
                        _cache[17] || (_cache[17] = _createTextVNode()),
                        _createElementVNode("i", null, _toDisplayString(_ctx.blogCounts.all), 1)
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.UNPUBLISHED_TEXT), 1),
                        _createElementVNode("i", null, _toDisplayString(_ctx.blogCounts.unpublished), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.blogCounts.published), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.PUBLISHED_BLOGS_TEXT), 1)
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "dashboard-item-col-mid-right" }, [
                        _createElementVNode("div", { class: "dashboard-item-col-icon" }, [
                          _createElementVNode("img", {
                            src: _imports_6,
                            alt: ""
                          })
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_router_link, {
                          to: "/authority/manage-blog",
                          id: "blogDetailsLink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.TOTAL_TEXT), 1),
                        _cache[19] || (_cache[19] = _createTextVNode()),
                        _cache[20] || (_cache[20] = _createElementVNode("i", null, "55", -1))
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.UNPUBLISHED_TEXT), 1),
                        _cache[21] || (_cache[21] = _createTextVNode()),
                        _cache[22] || (_cache[22] = _createElementVNode("i", null, "30", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.contactCounts), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.CONTACT_US_MENU), 1)
                      ]),
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "dashboard-item-col-mid-right" }, [
                        _createElementVNode("div", { class: "dashboard-item-col-icon" }, [
                          _createElementVNode("img", {
                            src: _imports_7,
                            alt: ""
                          })
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createVNode(_component_router_link, {
                          to: "/authority/contactUs",
                          id: "contactDetailsLink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.constants.TEAMS_TEXT), 1),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              id: "publishedLink",
                              class: _normalizeClass({ active: _ctx.teamMemberActiveTab === 1 }),
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setActiveTab(1)), ["prevent"]))
                            }, "PUBLISHED: " + _toDisplayString(_ctx.teamMemberCounts.published), 3)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              id: "unPublishedLink",
                              class: _normalizeClass({ active: _ctx.teamMemberActiveTab === 0 }),
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setActiveTab(0)), ["prevent"]))
                            }, "UNPUBLISHED: " + _toDisplayString(_ctx.teamMemberCounts.unpublished), 3)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _withDirectives(_createElementVNode("div", _hoisted_88, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (member) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "dashboard-team-col",
                            key: member.id
                          }, [
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("img", {
                                  src: _ctx.getCdnImageAddress(member.teamMemberImage, `w_60,h_60/`),
                                  alt: "member.name"
                                }, null, 8, _hoisted_91)
                              ]),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("h4", null, _toDisplayString(member.name), 1),
                                _createElementVNode("span", null, _toDisplayString(member.designation), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, _ctx.teamMemberActiveTab === 1]
                      ]),
                      (_ctx.teamMemberActiveTab === 1 && _ctx.teamMembers.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_93, " No Data To Display "))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("div", _hoisted_94, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (member) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "dashboard-team-col",
                            key: member.id
                          }, [
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", _hoisted_96, [
                                _createElementVNode("img", {
                                  src: _ctx.getCdnImageAddress(member.teamMemberImage, `w_60,h_60/`),
                                  alt: "member.name"
                                }, null, 8, _hoisted_97)
                              ]),
                              _createElementVNode("div", _hoisted_98, [
                                _createElementVNode("h4", null, _toDisplayString(member.name), 1),
                                _createElementVNode("span", null, _toDisplayString(member.designation), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, _ctx.teamMemberActiveTab === 0]
                      ]),
                      (_ctx.teamMemberActiveTab === 0 && _ctx.teamMembers.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, " No Data To Display "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createVNode(_component_router_link, {
                        to: "/authority/manage-team",
                        id: "jobsDetailslink",
                        class: "link-blue-arrow"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.constants.JOIN_OUR_TEAM_TEXT) + " (" + _toDisplayString(_ctx.joinOurTeamCounts) + ")", 1)
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.constants.NAME_LABEL), 1),
                          _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.constants.DESIGNATION_LABEL), 1),
                          _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.constants.ACTION_LABEL), 1)
                        ]),
                        _createElementVNode("div", _hoisted_111, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.joinOurTeam, (member, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "dashboard-join-team-col",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_112, [
                                _createElementVNode("img", {
                                  src: _ctx.getCdnImageAddress(member.candidateImage, `w_60,h_60/`),
                                  alt: "member.candidateName"
                                }, null, 8, _hoisted_113)
                              ]),
                              _createElementVNode("div", _hoisted_114, _toDisplayString(member.candidateName), 1),
                              _createElementVNode("div", _hoisted_115, _toDisplayString(member.designation), 1),
                              _createElementVNode("div", _hoisted_116, [
                                _createElementVNode("button", {
                                  class: "dashboard-join-team-download-btn",
                                  id: "cvDeonloadBtn",
                                  onClick: ($event: any) => (_ctx.downloadResume(member.id, member.candidateName))
                                }, [
                                  _cache[24] || (_cache[24] = _createElementVNode("i", null, [
                                    _createElementVNode("img", {
                                      src: _imports_8,
                                      alt: ""
                                    })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.constants.DOWNLOAD_BUTTON), 1)
                                ], 8, _hoisted_117)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      (_ctx.joinOurTeam.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, " No Data To Display "))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_119, [
                        _createVNode(_component_router_link, {
                          to: "/authority/join-team",
                          id: "jobsDetailslink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.constants.JOB_CATEGORY_TEXT) + " (" + _toDisplayString(_ctx.jobCategoryCounts) + ")", 1)
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("div", _hoisted_125, [
                          _createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                          _createElementVNode("div", _hoisted_127, _toDisplayString(_ctx.constants.ACTIVE_INACTIVE_LABEL), 1),
                          _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                        ]),
                        _createElementVNode("div", _hoisted_129, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobCategories, (member, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "dashboard-job-category-col",
                              key: member.id
                            }, [
                              _createElementVNode("div", _hoisted_130, _toDisplayString(member.title), 1),
                              _createElementVNode("div", _hoisted_131, [
                                _createElementVNode("div", {
                                  class: "active-inactive-radio",
                                  onClick: ($event: any) => (_ctx.toggleStatus(member.id, member.status, 'job-category'))
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "ActiveInput",
                                    type: "radio",
                                    name: 'job_status_' + member.id,
                                    class: "active-radio",
                                    "onUpdate:modelValue": ($event: any) => ((member.status) = $event),
                                    value: 1
                                  }, null, 8, _hoisted_133), [
                                    [_vModelRadio, member.status]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "InactiveInput",
                                    type: "radio",
                                    name: 'job_status_' + member.id,
                                    class: "inactive-radio",
                                    "onUpdate:modelValue": ($event: any) => ((member.status) = $event),
                                    value: 0
                                  }, null, 8, _hoisted_134), [
                                    [_vModelRadio, member.status]
                                  ]),
                                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "active-inactive-radio-img" }, null, -1))
                                ], 8, _hoisted_132)
                              ]),
                              _createElementVNode("div", _hoisted_135, [
                                _createElementVNode("ul", _hoisted_136, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("button", {
                                      id: "dashPgEditBtn",
                                      class: "editBtn",
                                      onClick: ($event: any) => (_ctx.goToEditPage(member.id, index))
                                    }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_137)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("button", {
                                      id: "dashPgDeleteBtn",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#deletePop",
                                      onClick: ($event: any) => (_ctx.setDeleteMode( member.id))
                                    }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_138)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_139, [
                        _createVNode(_component_router_link, {
                          to: "/authority/job-category",
                          id: "jobsDetailslink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_140, [
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.constants.BLOG_CATEGORY_TEXT) + " (" + _toDisplayString(_ctx.blogCategoryCounts) + ")", 1)
                    ]),
                    _createElementVNode("div", _hoisted_143, [
                      _createElementVNode("div", _hoisted_144, [
                        _createElementVNode("div", _hoisted_145, [
                          _createElementVNode("div", _hoisted_146, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                          _createElementVNode("div", _hoisted_147, _toDisplayString(_ctx.constants.ACTIVE_INACTIVE_LABEL), 1),
                          _createElementVNode("div", _hoisted_148, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                        ]),
                        _createElementVNode("div", _hoisted_149, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogCategories, (blog, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "dashboard-blog-category-col",
                              key: blog.id
                            }, [
                              _createElementVNode("div", _hoisted_150, _toDisplayString(blog.title), 1),
                              _createElementVNode("div", _hoisted_151, [
                                _createElementVNode("div", {
                                  class: "active-inactive-radio",
                                  onClick: ($event: any) => (_ctx.toggleStatus(blog.id, blog.status,'blog-category'))
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "ActiveInput",
                                    type: "radio",
                                    name: 'blog_status_' + blog.id,
                                    class: "active-radio",
                                    "onUpdate:modelValue": ($event: any) => ((blog.status) = $event),
                                    value: 1
                                  }, null, 8, _hoisted_153), [
                                    [_vModelRadio, blog.status]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "InactiveInput",
                                    type: "radio",
                                    name: 'blog_status_' + blog.id,
                                    class: "inactive-radio",
                                    "onUpdate:modelValue": ($event: any) => ((blog.status) = $event),
                                    value: 0
                                  }, null, 8, _hoisted_154), [
                                    [_vModelRadio, blog.status]
                                  ]),
                                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "active-inactive-radio-img" }, null, -1))
                                ], 8, _hoisted_152)
                              ]),
                              _createElementVNode("div", _hoisted_155, [
                                _createElementVNode("ul", _hoisted_156, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("button", {
                                      id: "dashPgEditBtn",
                                      class: "editBtn",
                                      onClick: ($event: any) => (_ctx.goToBlogEditPage(blog.id, index))
                                    }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_157)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("button", {
                                      id: "dashPgDeleteBtn",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#deletePop",
                                      onClick: ($event: any) => (_ctx.setBlogDeleteMode( blog.id))
                                    }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_158)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_159, [
                        _createVNode(_component_router_link, {
                          to: "/authority/blog-category",
                          id: "jobsDetailslink",
                          class: "link-blue-arrow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.constants.DETAILS_LINK), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_160, [
      _createElementVNode("div", _hoisted_161, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_162, [
      _createElementVNode("div", _hoisted_163, [
        _createElementVNode("div", _hoisted_164, [
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_9,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_165, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1),
          _createElementVNode("div", _hoisted_166, [
            _createElementVNode("button", {
              id: "popNoBtn",
              class: "admin-btn-outline-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jobCategorieToDelete=null,_ctx.blogCategorieToDelete=null))
            }, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteCategorie()))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}